<template>
  <div
    class="vexellent w-100 h-100 d-flex align-items-center justify-content-center"
    :class="{ 'position-fixed vexellent-page': page }"
  >
    <b-container class="text-center">
      <div class="animation-container mt-3">
        <Lottie :options="defaultOptions" :height="200" :width="200" :loop="true" />
      </div>
      <h1 class="title mb-4">{{ title }}</h1>
      <div class="w-100 d-flex justify-content-center mb-4">
        <!-- eslint-disable max-len vue/no-v-html -->
        <Button
          v-bind="buttonProps"
          :to="hasSpins ? localePath('spin-wheel') : localePath('profile-account')"
          @click="removeModal"
        >
          {{ buttonText }}
        </Button>
      </div>
      <div class="utilities d-inline-flex justify-content-center">
        <div class="utility-container">
          <Icon color="white" :width="iconSize" :height="iconSize" icon="hottest" />
          <p>{{ $t('main.paymentSuccesful.content.text1') }}</p>
        </div>
        <div class="utility-container">
          <Icon color="white" :width="iconSize" :height="iconSize" icon="online-editor" />
          <p>{{ $t('main.paymentSuccesful.content.text2') }}</p>
        </div>
        <div class="utility-container">
          <Icon color="white" :width="iconSize" :height="iconSize" icon="license" />
          <p>{{ $t('main.paymentSuccesful.content.text3') }}</p>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import * as animationData from '~/assets/animations/bumpingFists/data.json';
import Lottie from '@/components/Common/Lottie.vue';
import Button from 'UI/Button';
import Icon from 'UI/Icon';

export default {
  components: {
    Lottie,
    Button,
    Icon
  },
  props: {
    page: {
      type: Boolean,
      require: false,
      default: true
    },
    vector: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data() {
    return {
      defaultOptions: { animationData: animationData.default },
      animationSpeed: 1,
      iconSize: 30,
      hasSpins: false,
      loadingSpins: true
    };
  },
  computed: {
    title() {
      return this.$t('main.paymentSuccesful.header.title');
    },
    buttonProps() {
      return {
        shape: 'square',
        color: 'green',
        size: 'big',
        withGradient: true,
        gradient:
          // eslint-disable-next-line max-len
          'linear-gradient(to right, white 0%, white 43%, rgba(202,221,252,1) 89%, rgba(195,216,250,1) 95%, rgba(184,211,255,1) 100%)',
        fontColor: '#3f80f1'
      };
    },
    buttonText() {
      return this.hasSpins
        ? this.$t('main.paymentSuccesful.button.textSeasonal')
        : this.$t('main.paymentSuccesful.button.text');
    }
  },
  async mounted() {
    if (this.page) {
      if (this.vector?.id) {
        const path = {
          path: `/vectors/preview/${this.vector.id}`,
          query: { forceDownload: true }
        };

        await this.$store.dispatch('downloads/DOWNLOAD_VECTOR', {
          id: this.vector.id,
          url: this.vector.urlDownload
        });

        setTimeout(() => {
          this.$router.push(path);
        }, 5000);
      }
    } else if (this.vector?.id) {
      const id = this.vector.id;
      const pathDownload = this.$store.getters['downloads/pathDownload']({
        id,
        type: 'vector',
        slug: this.vector.canonizedName
      });
      const data = { id, url: this.vector.urlDownload };

      this.$ga.page(pathDownload);
      this.$store.commit('downloads/SET_DOWNLOAD_PERMISSION', []);
      await this.$store.dispatch('downloads/DOWNLOAD_VECTOR', data);
    }
  },
  methods: {
    removeModal() {
      if (!this.page) {
        if (this.vector?.id) {
          this.$bvModal.hide('preview-vector-modal');
        } else {
          this.$bvModal.hide('purchase-modal');
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.vexellent {
  background-image: url('https://cdn.vexels.com/img/vexellent-background.jpg');
  background-size: cover;
  background-position: center;
  border-radius: 5px;
  &.seasonal {
    background: $blackFriday;
    padding: 0 0 40px 0;
    .spin-loading-container {
      height: 80px;
    }
  }
  .animation-container {
    margin: auto;
    @include md {
      width: 100%;
    }
  }
  .title {
    color: #ffffff;
    font-size: 32px;
    display: inline-block;
    @include md {
      font-size: 45px;
    }
  }
  .utilities {
    flex-wrap: wrap;
    .utility-container {
      color: #ffffff;
      margin: 15px;
      width: 140px;
      p {
        font-size: 13px;
        font-weight: 500;
        line-height: 15px;
      }
    }
  }
}

.vexellent-page {
  top: 0;
  left: 0;
  z-index: 2000;
  padding: 0px;
  .animation-container {
    width: 500px !important;
    height: 300px !important;
  }
  .title {
    font-size: 65px !important;
  }
}
</style>
